import React from 'react';
import T from 'i18n-react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import AppDialog from '../Dialog/AppDialog';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import camelCase from 'lodash/camelCase';

const useStyles = makeStyles((theme) => ({
  dialogContentContainer: {
    textAlign: 'center',
  },
  imageContainer: {
    marginBottom: theme.spacing(1),
  },
  image: {
    maxHeight: 240,
  },
  kindName: {
    fontWeight: 'bold',
  },
  imageDescription: {
    overflowWrap: 'break-word',
    marginBottom: theme.spacing(2),
  },
  buttonImage: {
    maxWidth: 90,
  },
}));

const FacilityImagesButton = ({ images = [], children }) => {
  const dialogRef = React.useRef();
  const classes = useStyles();

  const [selectedImage, setSelectedImage] = React.useState(images[0]);

  const handleClickButton = () => {
    setSelectedImage(images[0]);
    dialogRef.current?.handleOpen();
  };

  const handleCloseDialog = () => {
    dialogRef.current?.handleSuccess();
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={handleClickButton}
        disabled={images.length === 0}
      >
        {children}
      </Button>
      <AppDialog
        ref={dialogRef}
        title={T.translate('plan.facility.viewDialog.title')}
        disableCancelButton
        actionButtonText={T.translate('close')}
        onAccept={handleCloseDialog}
        contentNode={
          <Grid
            container
            justify="center"
            alignItems="center"
            className={classes.dialogContentContainer}
          >
            <Grid item xs={12} className={classes.imageContainer}>
              <img src={selectedImage?.url} className={classes.image} />
            </Grid>
            {selectedImage && (
              <>
                <Grid item xs={12}>
                  <Typography className={classes.kindName}>
                    {T.translate(
                      `plan.facility.images.${camelCase(selectedImage.kind)}`,
                    )}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography className={classes.imageDescription}>
                    {selectedImage.description}
                  </Typography>
                </Grid>
              </>
            )}
            {images.map((image, index) => (
              <Grid key={index} item>
                <Button onClick={() => setSelectedImage(images[index])}>
                  <img src={image.url} className={classes.buttonImage} />
                </Button>
              </Grid>
            ))}
          </Grid>
        }
      />
    </>
  );
};

export default FacilityImagesButton;
